<template>
  <el-table show-summary :data="tableData" border style="width: 100%" :key="tableKey">
    <el-table-column min-width="100" prop="color_option_value.name" label="颜色" />
    <el-table-column min-width="100" prop="size_option_value.name" label="尺寸" />
    <el-table-column min-width="100" prop="quantity" label="数量" />
    <el-table-column min-width="120" v-for="(item, index) in accessories" :key="index" :prop="`accessory-${index}-quantity`">
      <template #header>
        <el-image style="width: 60px; height: 60px" :src="item.image.url" :preview-src-list="[item.image.url]" />
        <div style="font-weight: normal; color: #000">{{ item.name }}</div>
        <template>
          <el-tag v-if="item.received" size="mini" type="success">已签收</el-tag>
          <el-tag v-else size="mini" type="warning">未签收</el-tag>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';

export function getTableData(lineItems = [], accessories = []) {
  const tableData = (lineItems || []).map((lineItem) => {
    const row = { ...lineItem };
    (accessories || []).forEach((accessory, accessoryIndex) => {
      row[`accessory-${accessoryIndex}-quantity`] = _.get(lineItem, `line_item_accessories.${accessoryIndex}.quantity`);
    })
    return row;
  });
  return tableData;
}

@Component
export default class LineItemTable extends Vue {
  @Prop(Array) accessories;
  @Prop(Array) lineItems;

  tableKey = Date.now();

  get tableData() {
    return getTableData(this.lineItems, this.accessories);
  }

  @Watch('accessories')
  @Watch('lineItems')
  onChange() {
    // 表头图片不更新
    this.tableKey = Date.now();
  }
}
</script>
